export default __webpack_public_path__ + "static/media/image5tum.e29839b0.jpg";